// extracted by mini-css-extract-plugin
module.exports = {"body":"SimpleDropdown_body","cell":"SimpleDropdown_cell","ord1":"SimpleDropdown_ord1","ord2":"SimpleDropdown_ord2","selected":"SimpleDropdown_selected"};